/** Map assignment role → bubble ring + tooltip. Executive login forces dashed. */
export function resolveAccountBubbleRole(
  account,
  { forceExecutiveRing = false } = {}
) {
  if (forceExecutiveRing) {
    return { strokeClass: "acct-bubble--executive", label: "Executive" };
  }
  const role = String(account.roleType || account.role_type || "")
    .trim()
    .toLowerCase();
  if (role === "primary") {
    return { strokeClass: "acct-bubble--primary", label: "Primary" };
  }
  if (role === "secondary") {
    return { strokeClass: "acct-bubble--secondary", label: "Secondary" };
  }
  if (role === "account_team") {
    return { strokeClass: "acct-bubble--secondary", label: "Account Team" };
  }
  if (role === "additional" || role === "extra_sponsor") {
    return { strokeClass: "acct-bubble--executive", label: "Executive" };
  }
  return { strokeClass: "", label: null };
}
